// extracted by mini-css-extract-plugin
module.exports = {"root":"TripCartPanelTitle_root__6_Y1m","root_border":"TripCartPanelTitle_root_border__rK9C2","title":"TripCartPanelTitle_title__Purw3","close":"TripCartPanelTitle_close__qOUNA"};